import { useFormContext } from "react-hook-form";
import moment from "moment";
import FormInput from "../../Elements/FormInput";
import { ICreditPaymentoForm } from "../../../types/forms";
import { cpfMask, dateMask, phoneMask } from "../../../utils/formMasks";
import { IUserData } from "../../../providers/user/types";

interface CardHolderSectionProps {
  userData: IUserData;
}

const CardHolderSection = ({ userData }: CardHolderSectionProps) => {
  const { 
    register, 
    setValue, 
    formState: { errors } 
  } = useFormContext<ICreditPaymentoForm>();

  return (
    <>
      <h5 className="m-0">
        Dados do Titular do Cartão
      </h5>
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.cpfOwner?.message}
              onChange={(e) => setValue("cpfOwner", cpfMask(e.target.value))}
              defaultValue={!!userData.cpf ? cpfMask(userData?.cpf) : ""}
              name="cpfOwner"
              type="text"
              id="txtCPFTitular"
              placeholder="CPF do Titular:"
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.phoneOwner?.message}
              onChange={(e) =>
                setValue("phoneOwner", phoneMask(e.target.value))
              }
              defaultValue={phoneMask(
                `${userData.dddMobilePhone}${userData?.mobilePhone}`
              )}
              name="phoneOwner"
              type="text"
              id="txtTelefoneTitular"
              placeholder="Telefone do Titular:"
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-floating">
            <FormInput
              register={register}
              error={errors.birthdayOwner?.message}
              onChange={(e) =>
                setValue("birthdayOwner", dateMask(e.target.value))
              }
              defaultValue={moment(userData.birthDate).format("DD/MM/YYYY")}
              name="birthdayOwner"
              type="text"
              id="txtDataNascTitular"
              placeholder="Data de Nascimento do Titular:"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CardHolderSection;